import React from 'react';
import { FormikInput } from 'components/UiKit/FormikFields';
import PersonFieldLabel from '../PersonFieldLabel';

function FullNameField() {
  return (
    <div className="my-4 w-full">
      <div className="block">
        <div className="w-full">
          <PersonFieldLabel htmlFor="full-name-input">Name*</PersonFieldLabel>
        </div>
        <div className="w-full">
          <FormikInput id="full-name-input" name="fullName" />
        </div>
      </div>
    </div>
  );
}

export default FullNameField;
